// eslint-disable-next-line no-unused-vars
const activeOptions = {};

// eslint-disable-next-line no-unused-vars
function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

// Lets more than one modal ask for the chat widget to be hidden without the
// first one to close revealing it while another is still open.
const chatWidgetHideRequests = new Set();

function applyChatWidgetVisibility() {
  const hidden = chatWidgetHideRequests.size > 0;

  // The Permut widget lives in a shadow root we don't control, so we can't
  // toggle a class/display on it directly. A CSS custom property on
  // documentElement inherits through the shadow boundary, letting the
  // stylesheet injected in layout/theme.liquid read it instead.
  document.documentElement.style.setProperty(
    '--brn-permut-z-index',
    hidden ? '1' : '100',
  );
}

// eslint-disable-next-line no-unused-vars
function setChatWidgetHidden(hidden, requesterId) {
  if (hidden) {
    chatWidgetHideRequests.add(requesterId);
  } else {
    chatWidgetHideRequests.delete(requesterId);
  }

  applyChatWidgetVisibility();
}

// eslint-disable-next-line no-unused-vars
function getStyleProperty(element, property) {
  return window.getComputedStyle(element).getPropertyValue(property);
}

/*
 * Shopify Common JS
 *
 */

if (typeof window.Shopify === "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (let i = 0, count = selector.options.length; i < count; i++) {
    const option = selector.options[i];
    if (value === option.value || value === option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent(`on${eventName}`, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  const method = options.method || "post";
  const params = options.parameters || {};

  const form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (const key in params) {
    const hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }

  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options,
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options.hideElement || province_domid,
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this),
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry() {
    const value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince() {
    const value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler() {
    const opt = this.countryEl.options[this.countryEl.selectedIndex];
    const raw = opt.getAttribute("data-provinces");
    const provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length === 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (let i = 0; i < provinces.length; i++) {
        const opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions(selector, values) {
    for (let i = 0; i < values.length; i++) {
      const opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class QuantityCounter extends HTMLElement {
  constructor() {
    super();
    this.changeEvent = new Event("change", { bubbles: true });
  }

  connectedCallback() {
    this.counterEl = this.querySelector(".js-counter-quantity");
    this.increaseBtn = this.querySelector(".js-counter-increase");
    this.decreaseBtn = this.querySelector(".js-counter-decrease");

    this.min = parseInt(this.counterEl.min) || 1;
    this.max = parseInt(this.counterEl.max) || 999;

    this.increaseBtn.addEventListener("click", this.onIncrease.bind(this));
    this.decreaseBtn.addEventListener("click", this.onDecrease.bind(this));

    this.updateIncreaseBtnState();
  }

  get effectiveMax() {
    const inventoryQty = parseInt(this.counterEl?.dataset?.inventoryQty);
    if (!isNaN(inventoryQty)) return Math.min(this.max, inventoryQty);
    return this.max;
  }

  onIncrease() {
    const currentValue = parseInt(this.counterEl.value);
    if (currentValue >= this.effectiveMax) {
      this.showQuantityLimitError();
      return;
    }
    this.updateValue(currentValue + 1);
    this.updateIncreaseBtnState();
  }

  onDecrease() {
    const currentValue = parseInt(this.counterEl.value);
    // Respect cart removal: if next value would be below variant min, set to 0
    const attrMin = parseInt(this.counterEl.min) || 1;
    const nextValue = currentValue - 1;
    if (this.dataset.cart) this.min = 0;
    if (this.dataset.cart && nextValue < attrMin) {
      const line = this.counterEl.dataset.index;
      const cartItemsEl = this.closest('cart-items') || this.closest('cart-drawer-items');
      document.dispatchEvent(new CustomEvent('cart:remove-requested', {
        detail: { line, cartItemsEl }
      }));
      return;
    }
    if (currentValue > this.min) {
      this.updateValue(nextValue);
      this.updateIncreaseBtnState();
    }
  }

  updateValue(value) {
    this.counterEl.value = value;
    this.counterEl.dispatchEvent(this.changeEvent);
  }

  updateIncreaseBtnState() {
    const currentValue = parseInt(this.counterEl.value);
    this.increaseBtn.disabled = currentValue >= this.effectiveMax;
  }

  showQuantityLimitError() {
    const line = parseInt(this.counterEl.dataset.index);
    if (!line) return;
    const errorEl =
      document.getElementById(`CartDrawer-LineItemError-${line}`) ||
      document.getElementById(`Line-item-error-${line}`);
    if (!errorEl) return;
    const msg = (window.cartStrings?.quantityError || "").replace("[quantity]", this.max);
    errorEl.querySelector(".wt-cart__error-text").innerHTML = msg;
    errorEl.style.display = "flex";
    errorEl.removeAttribute("hidden");
  }
}

// Define the custom element
window.customElements.define("quantity-counter", QuantityCounter);

// without under functions main-password doesn't work

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
    ),
  );
}

// eslint-disable-next-line no-unused-vars
function toggleTabindex(elements) {
  elements.forEach((el) => {
    const tabindex = el.getAttribute("tabindex");
    el.setAttribute("tabindex", tabindex === "0" ? "-1" : "0");
  });
}

// eslint-disable-next-line no-unused-vars
function setTabindex(elements, tabindex) {
  elements.forEach((el) => {
    el.setAttribute("tabindex", tabindex);
  });
}

// Helper function to add multiple event listeners with the same handler
// eslint-disable-next-line no-unused-vars
function addEventListeners(element, events, handler) {
  events.forEach((event) => element.addEventListener(event, handler));
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open"),
  );

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open"),
    );
  });

  if (summary.closest("header-drawer, menu-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

// eslint-disable-next-line no-unused-vars
function trapFocus(container, elementToFocus = container) {
  const elements = getFocusableElements(container);
  const first = elements[0];
  const last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === "INPUT" &&
    ["search", "text", "email", "url"].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

// ProductRecommendations async loading removed - now renders directly with Liquid

/**
 * Utility to detect option types (size/color) across all supported languages.
 * Supports: EN, ES, FR, IT, DE, NL, PT, CA
 */
window.OptionTypeUtils = {
  SIZE_NAMES: ['size', 'talla', 'taille', 'taglia', 'maat', 'tamanho', 'größe', 'groesse', 'grösse', 'grosse'],
  COLOR_NAMES: ['color', 'colour', 'couleur', 'colore', 'kleur', 'cor', 'farbe'],

  isSize(optionName) {
    if (!optionName) return false;
    const name = optionName.toLowerCase().trim();
    return this.SIZE_NAMES.some(s => name === s || name.includes(s));
  },

  isColor(optionName) {
    if (!optionName) return false;
    const name = optionName.toLowerCase().trim();
    return this.COLOR_NAMES.some(c => name === c || name.includes(c));
  }
};

Shopify.formatMoney = function (cents, format) {
  if (typeof cents === 'string') cents = cents.replace('.', '');
  const formatString = format || window.moneyFormat || '{{amount}} €';
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

  function formatWithDelimiters(number, precision, thousands, decimal) {
    if (isNaN(number) || number == null) return '0';
    precision = precision == null ? 2 : precision;
    thousands = thousands == null ? '.' : thousands;
    decimal = decimal == null ? ',' : decimal;
    number = (number / 100.0).toFixed(precision);
    const parts = number.split('.');
    parts[0] = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    return parts[0] + (parts[1] ? decimal + parts[1] : '');
  }

  const match = formatString.match(placeholderRegex);
  if (!match) return formatString;
  let value;
  switch (match[1]) {
    case 'amount': value = formatWithDelimiters(cents, 2); break;
    case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
    case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
    case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
    default: value = formatWithDelimiters(cents, 2); break;
  }
  return formatString.replace(placeholderRegex, value);
};

window.CartAddSections = {
  BUBBLE: 'cart-icon-bubble',

  attach(formData) {
    formData.append('sections', this.BUBBLE);
    formData.append('sections_url', window.location.pathname);
    return formData;
  },

  applyBubble(response) {
    const html = response?.sections?.[this.BUBBLE];
    if (!html) return undefined;

    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const section = parsed.querySelector('.shopify-section');
    const target = document.getElementById('cart-icon-bubble');
    if (section && target) target.innerHTML = section.innerHTML;

    const count = Number(parsed.querySelector('.wt-header__panel__counter')?.textContent?.trim());
    return Number.isFinite(count) ? count : undefined;
  },
  refreshDrawer() {
    document.dispatchEvent(new CustomEvent('cart-drawer:refresh'));
  },
};
